<template>
  <v-layout fill-height>
    <v-container fluid v-if="!loadingSection">
      <page-bar
        :title="sectionTitle"
        :subtitle="sectionSubtitle"
        :image-src="sectionImageSrc"
      >
        <template v-slot:actions>
          <v-btn
            v-if="CanUserEditAssets()"
            small
            color="green"
            dark
            class="ma-0"
            @click="$router.push('settings/' + sectionName)"
          >
            Section Settings
          </v-btn>
          <v-btn
            v-if="CanUserEditAssets()"
            small
            color="green"
            dark
            class="ma-0"
            @click="sectionImageDialog = true"
          >
            Edit Image
          </v-btn>
        </template>
      </page-bar>

      <v-row>
        <v-col cols="12" id="Section Actions" class="pb-0">
          <div class="px-6 py-4">
            <grid-system :columns="{ xs: 1, sm: 2, md: 3, lg: 4 }" :gap="12">
              <div>
                <CardSection
                  dense
                  :title="'Browse Catalogue'"
                  icon="mdi-view-grid-outline"
                  @click="$router.push('catalogue/' + sectionName)"
                />
              </div>
              <div>
                <CardSection
                  dense
                  :title="'Search'"
                  icon="mdi-magnify"
                  @click="$router.push(sectionName + '/search')"
                />
              </div>
              <div v-if="CanUserAccessAddUpdateAssets()">
                <CardSection
                  dense
                  :title="'Add / Update'"
                  icon="mdi-pencil"
                  @click="$router.push('addupdateassets/' + sectionName)"
                />
              </div>
              <div>
                <CardSection
                  dense
                  :title="'Export Assets'"
                  icon="mdi-file-export-outline"
                  @click="downloadSectionData()"
                />
              </div>
            </grid-system>
          </div>
        </v-col>
        <v-col cols="12" id="Section Categories" class="pt-1">
          <div class="px-6 py-4">
            <v-card width="100%" height="100%">
              <v-col class="pt-0">
                <v-row>
                  <v-card
                    color="primaryDark"
                    width="100%"
                    dark
                    class="pa-2 subtitle-1"
                  >
                    <v-row justify="start">
                      <v-col cols="5" md="5" lg="8" class="pl-4">
                        Categories
                      </v-col>
                      <v-col justify-self="end">
                        <v-text-field
                          dense
                          hide-details=""
                          label="Search"
                          v-model="categorySearch"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2" md="3" lg="2" v-if="CanUserEditAssets()">
                        <v-btn
                          @click="newCategoryDialog = true"
                          class="ma-0 hidden-xs-only"
                          small
                          dense
                          height="28px"
                          width=""
                          >New Category +</v-btn
                        >
                        <v-btn
                          @click="newCategoryDialog = true"
                          icon
                          text
                          class="ma-0 hidden-sm-and-up"
                          small
                          dense
                          height="28px"
                          width=""
                          ><v-icon>mdi-plus</v-icon></v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-card>
                </v-row>
                <v-data-iterator
                  class="pa-2"
                  :items="section.categories"
                  :items-per-page.sync="itemsPerPage"
                  :footer-props="{ itemsPerPageOptions }"
                  :search="categorySearch"
                  dense
                >
                  <template v-slot:default="props">
                    <grid-system
                      :columns="{ xs: 2, sm: 2, md: 4, lg: 4 }"
                      :gap="8"
                    >
                      <div v-for="(item, index) in props.items" :key="index">
                        <v-card class="ma-0 pa-0">
                          <v-container>
                            <v-row hover dense class="pl-2 subtitle-1">
                              <v-col cols="9" dense>
                                <v-btn
                                  text
                                  class="ma-0"
                                  v-on:click.stop="OnClickCategory(item)"
                                >
                                  {{ item.name }}
                                </v-btn>
                              </v-col>
                              <v-col cols="1" v-if="CanUserEditAssets()">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-btn
                                      icon
                                      class="ma-0"
                                      v-on:click="OnTapEditCategory(item)"
                                    >
                                      <v-icon size="25" dark v-on="on"
                                        >mdi-pencil</v-icon
                                      >
                                    </v-btn>
                                  </template>
                                  <span>Edit Category</span>
                                </v-tooltip>
                              </v-col>
                              <v-col cols="1" v-if="CanUserEditAssets()">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-btn
                                      icon
                                      class="ma-0"
                                      v-on:click="
                                        showCategoryDeletePrompt = true;
                                        categoryToDelete = item;
                                      "
                                    >
                                      <v-icon size="25" dark v-on="on"
                                        >mdi-delete</v-icon
                                      >
                                    </v-btn>
                                  </template>
                                  <span>Delete Category</span>
                                </v-tooltip>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card>
                      </div>
                    </grid-system>
                  </template>
                </v-data-iterator>
              </v-col>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <Loading v-if="loadingSection"></Loading>

    <v-dialog
      v-model="showingDeletePrompt"
      width="500px"
      height="200px"
      v-if="CanUserEditAssets()"
    >
      <v-card>
        <v-card-title class="headline">Delete this section?</v-card-title>

        <v-card-text>
          Are you sure you want to delete section
          <b>{{ section != null ? section.name : "" }}</b
          >?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            style="width:100px"
            color="green darken-1"
            dark
            @click="showingDeletePrompt = false"
          >
            Cancel
          </v-btn>

          <v-btn
            style="width:150px"
            color="red darken-1"
            dark
            @click="DeleteSection"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showCategoryDeletePrompt"
      width="500px"
      height="200px"
      v-if="CanUserEditAssets()"
      persistent
    >
      <v-card>
        <v-card-title class="pa-3 headline">Delete Category</v-card-title>

        <v-card-text class="cardcontent">
          <v-row class="subtitle-1">
            <span
              >Are you sure you want to delete category
              <b>{{ categoryToDelete != null ? categoryToDelete.name : "" }}</b
              >?</span
            >
          </v-row>
          <v-row>
            Deleting this category will remove all assets within the category.
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="!this.deletingCategory"
            style="width:100px"
            color="green darken-1"
            dark
            @click="showCategoryDeletePrompt = false"
          >
            Cancel
          </v-btn>

          <v-btn
            style="width:150px"
            color="red darken-1"
            dark
            @click="DeleteCategoryAndAssets"
          >
            <v-icon v-if="this.deletingCategory" size="28" color="white" dark>
              mdi-loading mdi-spin
            </v-icon>
            <span v-else>Confirm</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="newCategoryDialog"
      width="500px"
      height="200px"
      v-if="CanUserEditAssets()"
    >
      <v-card>
        <v-card-title class="headline">Create new Category</v-card-title>

        <v-card-text>
          <v-text-field
            label="Category Name"
            v-model="newCategoryName"
          ></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            style="width:100px"
            color="red darken-1"
            dark
            @click="newCategoryDialog = false"
            v-if="CanUserEditAssets()"
          >
            Cancel
          </v-btn>

          <v-btn
            style="width:150px"
            color="green darken-1"
            dark
            @click="CreateCategory"
            v-if="CanUserEditAssets()"
          >
            Create
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="editCategoryDialog"
      width="500px"
      height="200px"
      v-if="CanUserEditAssets()"
    >
      <v-card class="pa-2">
        <v-card-title class="headline">Edit existing category</v-card-title>

        <v-card-text>
          <v-text-field
            hide-details
            label="Category Name"
            v-model="editedCategoryName"
          ></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            style="width:100px"
            color="red darken-1"
            dark
            @click="editCategoryDialog = false"
            v-if="CanUserEditAssets()"
          >
            Cancel
          </v-btn>

          <v-btn
            style="width:150px"
            color="green darken-1"
            dark
            @click="UpdateSelectedCategory()"
            v-if="CanUserEditAssets()"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="sectionImageDialog"
      max-width="800px"
      v-if="CanUserEditAssets()"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Upload Resources</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="4" class="pa-1" justify="center" align="center">
                <v-card height="190px" class="justify-center">
                  <v-img
                    max-height="190px"
                    contain
                    :src="files.length ? files[0].thumb : ''"
                  />
                </v-card>
              </v-col>
              <v-col cols="8" class="pa-1">
                <v-card
                  class="upload"
                  color="transparent"
                  min-height="200px"
                  flat
                >
                  <v-simple-table v-if="files.length">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">File Name</th>
                          <th class="text-left"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(file, index) in files" :key="file.id">
                          <td>{{ file.name }}</td>
                          <td>
                            <v-btn
                              class="icon-btn"
                              color="red"
                              icon
                              @click="files.splice(index, 1)"
                            >
                              <v-icon>mdi-file-remove</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>

                  <v-container class="fill-height pa-4" fluid>
                    <v-row justify="center" align="center">
                      <v-btn>
                        <label
                          for="file"
                          class="btn btn-lg btn-primary"
                          style=""
                        >
                          Drop or Select Files
                        </label>
                      </v-btn>
                    </v-row>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-row justify="center" style="margin: 0px">
            <v-btn
              color="blue darken-1"
              text
              @click="sectionImageDialog = false"
              >Close</v-btn
            >
            <v-btn color="blue darken-1" text @click="Upload()">
              <v-icon
                v-if="$refs.upload && this.$refs.upload.uploading"
                size="28"
                color="green"
                dark
              >
                mdi-loading mdi-spin
              </v-icon>
              <span v-else>Upload</span>
            </v-btn>
          </v-row>
        </v-card-actions>
        <file-upload
          :post-action="postEndPoint"
          :headers="GetAuthHeaderObj()"
          :multiple="false"
          :drop="true"
          :drop-directory="true"
          :maximum="1"
          accept="image/*"
          @input-filter="inputFilter"
          v-model="files"
          ref="upload"
        ></file-upload>
      </v-card>
    </v-dialog>
    <v-dialog v-model="downloadingSectionData" width="600px">
      <v-card width="600px" height="250px">
        <h2 class="pt-3 pl-3">
          <span class="pr-3">Exporting Assets, please wait...</span>
          <v-icon size="28" color="green" dark>mdi-loading mdi-spin</v-icon>
        </h2>
        <JobProgress
          ref="exportProgress"
          v-if="this.downloadingSectionData"
          :importJobId="this.exportJobId"
        ></JobProgress>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import CONFIG from "../../../appconfig.json";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";

import Loading from "../../shared/Loading";
import TextEditor from "../../shared/TextEditor";
import FileUpload from "vue-upload-component";
import JobProgress from "../../shared/JobProgress";
import GridSystem from "../../shared/GridSystem";
import PageBar from "../../shared/PageBar";
import CardSection from "../../cards/CardSection";

export default {
  components: {
    TextEditor,
    Loading,
    FileUpload,
    JobProgress,
    GridSystem,
    PageBar,
    CardSection,
  },
  props: {
    //Name of section
    sectionName: {
      default: "",
      type: String,
    },
  },
  computed: {
    ...mapState("assetxpstate", ["section"]),
    sectionTitle() {
      return this.section && this.section.name
        ? this.section.name + " Summary"
        : "Section Summary";
    },
    sectionSubtitle() {
      return this.section && this.section.description
        ? this.section.description
        : "";
    },
    sectionImageSrc() {
      return this.section && this.section.thmUrl
        ? this.section.thmUrl + this.sasToken()
        : "";
    },

    postEndPoint() {
      if (this.section != null)
        return (
          CONFIG.platformEndpoints.assetxpapi +
          "section/uploadsectionimage/" +
          this.section.id
        );
      else return "Invalid";
    },
    uploadComplete() {
      return Object.values(this.files).every((file) => file.success);
    },
  },
  mounted: function() {
    this.LoadSection();
  },
  data: () => ({
    exportJobId: null,
    sectionImageDialog: false,
    files: [],
    file: {},
    categoryToDelete: null,
    showCategoryDeletePrompt: false,
    newCategoryName: "",
    newCategoryDialog: false,
    editedCategory: null,
    editedCategoryName: "",
    editCategoryDialog: false,
    cardActions: [
      {
        title: "Delete",
        action: "delete",
      },
    ],
    categorySearch: "",
    editableName: "",
    editableDesc: "",
    isEditing: false,
    showingDeletePrompt: false,
    loadingSection: true,
    itemsPerPage: 8,
    itemsPerPageOptions: [2, 4, 8, 16, 32, 64],
    downloadingSectionData: false,
    deletingCategory: false,
  }),
  methods: {
    ...mapGetters("authentication", [
      "CanUserEditAssets",
      "CanUserAccessAddUpdateAssets",
      "GetAuthHeaderObj",
      "sasToken",
    ]),
    ...mapActions("assetxpstate", [
      "GetSection",
      "RemoveSection",
      "UpdateSection",
      "UpsertCategoryInSection",
      "RemoveCategoryInSection",
      "ResetSelectedAsset",
      "ExportAssetsBySection",
      "StartNewJob",
      "RemoveCategoryAndAssets",
    ]),
    ...mapActions("navstate", ["GetSelectedSection"]),
    ...mapMutations("assetxpstate", ["ClearSectionSearchFromCache"]),
    async downloadSectionData() {
      this.downloadingSectionData = true;

      this.ExportAssetsBySection(this.section.id).then((response) => {
        this.downloadingSectionData = false;
      });
    },
    OnTapEditCategory(category) {
      this.editCategoryDialog = true;
      this.editedCategoryName = category.name;
      this.editedCategory = category;
    },
    UpdateSelectedCategory() {
      this.editedCategory.name = this.editedCategoryName;

      this.UpsertCategoryInSection({
        id: this.editedCategory.id,
        name: this.editedCategory.name,
        sectionid: this.section.id,
      }).then(() => {
        this.editCategoryDialog = false;
      });
    },
    CreateCategory() {
      this.UpsertCategoryInSection({
        name: this.newCategoryName,
        sectionid: this.section.id,
      }).then(() => {
        this.newCategoryName = "";
        this.newCategoryDialog = false;
      });
    },
    DeleteCategory() {
      this.RemoveCategoryInSection(this.categoryToDelete.id).then(() => {
        this.categoryToDelete = null;
        this.showCategoryDeletePrompt = false;
      });
    },
    DeleteCategoryAndAssets() {
      this.deletingCategory = true;

      this.RemoveCategoryAndAssets(this.categoryToDelete.id).then(() => {
        this.categoryToDelete = null;
        this.showCategoryDeletePrompt = false;
        this.deletingCategory = false;

        this.LoadSection();
      });
    },
    DeleteSection() {
      this.RemoveSection(this.section.id).then(() => {
        this.$router.push("/");
      });
    },
    LoadSection() {
      if (this.asset !== null) {
        this.ResetSelectedAsset();
      }

      if (this.section !== null) {
        if (this.section.name == this.sectionName) {
          this.loadingSection = false;
        }
      }

      this.GetSelectedSection(this.sectionName);

      this.GetSection(this.sectionName).then(() => {
        this.loadingSection = false;
      });
    },
    Upload() {
      this.$refs.upload.active = true;
    },
    OnClickCategory(category) {
      this.ClearSectionSearchFromCache(this.section.id);
      this.$router.push(this.sectionName + "/search/" + category.id);
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }

        // Filter php html js file
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }
      }

      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        // Create a blob field
        newFile.blob = "";
        let URL = window.URL || window.webkitURL;

        if (URL && URL.createObjectURL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }

        // Thumbnails
        newFile.thumb = "";

        if (newFile.blob && newFile.type.substr(0, 6) === "image/") {
          newFile.thumb = newFile.blob;
        }
      }
    },
    CompleteUpload() {
      this.sectionImageDialog = false;
      this.files = [];
      this.LoadSection();
    },
  },
  watch: {
    $route() {
      this.LoadSection();
    },
    uploadComplete(newValue) {
      if (newValue) {
        this.CompleteUpload();
      }
    },
  },
};
</script>

<style>
.btn-top-right {
  margin-top: 20 !important;
  margin-bottom: 0 !important;
  margin-right: 0 !important;
  right: 3px !important;
}
</style>
